import theme from './../../theme';

const PrivacyPolicyStyles = {
  container: {
    padding: '80px 20px',
    backgroundColor: theme.colors.extraLightGray,
    textAlign: 'center',
    maxWidth: '900px',
    margin: '0 auto',
  },
  title: {
    fontFamily: theme.fonts.secondary,
    fontWeight: '800',
    fontSize: '2.8rem',
    color: theme.colors.darkGray,
    marginBottom: '16px',
    '@media (max-width: 768px)': {
      fontSize: '2rem',
    },
  },
  subtitle: {
    fontFamily: theme.fonts.secondary,
    fontSize: '1.2rem',
    color: theme.colors.mediumGray,
    marginBottom: '40px',
  },
  section: {
    textAlign: 'left',
    marginBottom: '40px',
  },
  sectionTitle: {
    fontFamily: theme.fonts.secondary,
    fontWeight: '700',
    fontSize: '1.8rem',
    color: theme.colors.darkGray,
    marginBottom: '16px',
  },
  text: {
    fontFamily: theme.fonts.secondary,
    color: theme.colors.mediumGray,
    fontSize: '1rem',
    lineHeight: '1.8',
    '& ul': {
      paddingLeft: '20px',
    },
    '& li': {
      marginBottom: '10px',
    },
  },
};

export default PrivacyPolicyStyles;